var exports = {
  "A": "xa15a2ab7--31ff21--outer",
  "v": "xa15a2ab7--31ff21--inner",
};

module.exports = exports;
